import { App } from 'vue'
import EmailInput from './LpEmailInput.vue'

// @ts-ignore
EmailInput.install = (Vue: App) => {
  Vue.component(EmailInput.name, EmailInput)
}

export default EmailInput
